import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLaunch } from '../contexts/LaunchContext';
import { COMPANY, SUPPORT_EMAIL } from '../data/launch';
export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isPublicLaunch
  } = useLaunch();
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-gray-950 pt-16 pb-8 border-t-2 border-kitty-yellow" data-id="element-111" data-mp="3qcx8kbgauo39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112" data-mp="29z6x2jmuoxjl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-113" data-mp="29xvrqfdrbhqd">
          <div className="col-span-1 md:col-span-2" data-id="element-114" data-mp="2ezb99xgq7640">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-115" data-mp="3l9k65dxrvpdt">
              <div className="bg-white rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-116" data-mp="3l9sjf6xt4wpj">
                <img src="https://cdn.magicpatterns.com/uploads/vpaWAD2nLEfW1hoAd36jz7/LPot_only.png" alt="" className="w-[26px] h-[26px] object-contain" data-id="element-117" data-mp="3gc0ixoj3k29q" />
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-118" data-mp="82qtvx6261vu">
                KittyPot
              </span>
            </Link>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-119" data-mp="335trjf5jnhj">
              KittyPot helps groups track shared expenses, split costs fairly
              and keep track of who owes what.
            </p>
            <div className="flex gap-4" data-id="element-120" data-mp="cv1qaq1lb5jn">
              <a href="https://www.linkedin.com/company/kitty-pot/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="KittyPot on LinkedIn" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" data-id="element-121" data-mp="cw35n6pn2e76">
                <Linkedin className="w-5 h-5" aria-hidden="true" data-id="element-122" data-mp="13r7m2y4vwkn7" />
              </a>
              <a href="https://www.facebook.com/people/Kittypotapp/100089385062763/" target="_blank" rel="noopener noreferrer" aria-label="KittyPot on Facebook" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" data-id="element-123" data-mp="18lkbdot1kq6v">
                <Facebook className="w-5 h-5" aria-hidden="true" data-id="element-124" data-mp="3ocgi6ox89d6s" />
              </a>
              <a href="https://www.instagram.com/kittypotapp" target="_blank" rel="noopener noreferrer" aria-label="KittyPot on Instagram" className="w-10 h-10 rounded-full bg-white/[0.06] flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/[0.1] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow" data-id="element-125" data-mp="3t9gggdnu5bnc">
                <Instagram className="w-5 h-5" aria-hidden="true" data-id="element-126" data-mp="2tdzkmuvet5ua" />
              </a>
            </div>
          </div>

          <div data-id="element-127" data-mp="2pbutq3wcinbc">
            <h2 className="font-bold text-kitty-yellow mb-4" data-id="element-128" data-mp="2pc4i5n1qsmex">Product</h2>
            <ul className="space-y-3" data-id="element-129" data-mp="2kd1dw4tl6k80">
              <li data-id="element-130" data-mp="2kc02fz8nrvpr">
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-white transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-131" data-mp="2kbglakqu1bcs">
                  How it works
                </button>
              </li>
              <li data-id="element-132" data-mp="2rv7o9uxwjtzq">
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-white transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-133" data-mp="2ruogh71yulzf">
                  Features
                </button>
              </li>
              <li data-id="element-134" data-mp="2nrrur7h4q9r9">
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors" data-id="element-135" data-mp="3bjzzxq4quwfd">
                  FAQ
                </Link>
              </li>
              <li data-id="element-136" data-mp="31m2bp2mvwzmr">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors" data-id="element-137" data-mp="31khiphg7xor0">
                  About us
                </Link>
              </li>
              <li data-id="element-138" data-mp="1q4sukmr8ajom">
                <button onClick={() => scrollToSection('get-started')} className="text-gray-400 hover:text-white transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-yellow rounded" data-id="element-139" data-mp="1q8gohn0l583v">
                  {isPublicLaunch ? 'Get KittyPot' : 'Join the waitlist'}
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-140" data-mp="1rnjbydjjh3fp">
            <h2 className="font-bold text-kitty-yellow mb-4" data-id="element-141" data-mp="1rn1c76xo4731">Legal</h2>
            <ul className="space-y-3" data-id="element-142" data-mp="1rlq2kqhjk540">
              <li data-id="element-143" data-mp="13z06e5rvj4rb">
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-144" data-mp="13yi0sijbne6q">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-145" data-mp="1dpmhbmonb73o">
                <Link to="/delete-account" className="text-gray-400 hover:text-white transition-colors" data-id="element-146" data-mp="18xbeaaylz56w">
                  Delete account
                </Link>
              </li>
              <li data-id="element-147" data-mp="g7cizxttmbts">
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors" data-id="element-148" data-mp="g7uoll2di2ed">
                  Terms of Use
                </Link>
              </li>
              <li data-id="element-149" data-mp="2l7do0ocp6gl5">
                <Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors" data-id="element-150" data-mp="2q0oyczgpxfht">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-151" data-mp="1xct4s3mg43p9">
                <Link to="/disclaimer" className="text-gray-400 hover:text-white transition-colors" data-id="element-152" data-mp="1xdcbspak57oi">
                  Disclaimer
                </Link>
              </li>
              <li data-id="element-153" data-mp="27c1rcbezeg1l">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-154" data-mp="2bban1ltl0nzs">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/[0.08] flex flex-col items-center gap-4 text-center" data-id="element-155" data-mp="3mowbt5vj4nks">
          <p className="text-gray-400 text-sm max-w-2xl" data-id="element-156" data-mp="1b5gmas4lod76">
            KittyPot tracks shared expenses and settlement records. KittyPot
            does not hold or move money, group members settle up directly with
            each other.
          </p>
          <p className="text-gray-500 text-sm max-w-2xl" data-id="element-157" data-mp="xcqyci5igy7f">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="underline underline-offset-2 hover:text-gray-300 transition-colors" data-id="element-158" data-mp="xa4rkkqg2mq9">
              {SUPPORT_EMAIL}
            </a>
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 w-full mt-4" data-id="element-159" data-mp="jbo9xyr1nbtc">
            <p className="text-gray-500 text-sm" data-id="element-160" data-mp="edmqhcpphahc">
              © {COMPANY.copyrightYear} {COMPANY.legalName}. All rights
              reserved. Company Reg. {COMPANY.registrationNumber}
            </p>
            <p className="text-gray-500 text-sm" data-id="element-161" data-mp="28qurxn86skby">Designed in the UK 🇬🇧</p>
          </div>
        </div>
      </div>
    </footer>;
}